module.exports = __webpack_public_path__ + "static/evaluation-cf2a10d967e8ce48dea2cd9d1b3bf483.jpg";